import gql from 'graphql-tag'

export default gql`
{
  leave_unbillable_types{
    unbillable_type_id
    description
  }
}
`